import React from 'react';

function ShareButton() {
    const handleShare = () => {
        if (navigator.share) {
          navigator.share({
            title: 'Valentino Lovely Courting Experience',
            text: 'description text',
            url: document.location.href,
          })
          .then(() => {
            console.log('success Share');
            // Отслеживание события деления в Adobe Analytics
            if (window._satellite) {
              window._satellite.track('digitalcatalog', {
                'event': 'share'
              });
            }
          })
          .catch((error) => console.log('Error share detected:', error));
        } else {
          console.log('Web Share API not available.');
        }
      };

  return (
    <button onClick={handleShare}>Share</button>
  );
}

export default ShareButton;
